module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "approvecenter"
  }, [_c('rt-header', {
    attrs: {
      "title": _vm.$_t('审批处理', 'crm.approvelist'),
      "hide-tag": ""
    }
  }, [_c('rt-toolbar', {
    attrs: {
      "show-autoback": ""
    }
  })], 1), _vm._v(" "), _c('el-tabs', {
    class: _vm.approveShowBtn ? 'approve_card_btn' : 'approve_card',
    style: ({
      width: _vm.approvalWidth
    }),
    attrs: {
      "type": "border-card",
      "tab-position": _vm.tabPosition
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "page"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$_t('单据详情', 'approval.formdetail')))]), _vm._v(" "), (!_vm.formLogicalName) ? _c(_vm.formCom, {
    tag: "component"
  }) : _c('vformcore', {
    key: _vm.entityId,
    ref: "vformcore",
    attrs: {
      "objectId": _vm.entityId,
      "objectTypeName": _vm.entityName,
      "formLogicalName": _vm.formLogicalName,
      "formType": 0
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$_t('审批信息', 'approval.approvalinfo'),
      "name": "approve"
    }
  }, [_c('div', {
    staticClass: "rt-flow-left"
  }, [_c('rt-flow-approval-list', {
    ref: "_RTFlowApprovalList",
    attrs: {
      "entityname": _vm.entityName,
      "id": _vm.entityId
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "approve-box"
  }, [(_vm.isIfApprove) ? _c('div', {
    staticClass: "div_show"
  }, [_c('rc-icon', {
    staticClass: "approval-icon",
    attrs: {
      "size": 17,
      "name": _vm.isShowApprove ? 'rt-saas-fold-show-svg' : 'rt-saas-fold-hidden-svg',
      "color": "#4E5969"
    },
    on: {
      "click": function($event) {
        return _vm.onclickBtn()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "draw"
    }
  }, [_c('Approve', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowApprove && _vm.isIfApprove),
      expression: "isShowApprove&&isIfApprove"
    }]
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c6eb58e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/vflow/ApproveCenter.vue
// module id = 2157
// module chunks = 228